import React from 'react';
import pt from 'prop-types';
import Icon from 'components/icon';
import StorefrontEditorIcon from 'components/storefront/editor/icon';

function SwellColorPanelFooterActions({ onDuplicate, onDelete }) {
  const [menu, setMenu] = React.useState(false);
  const menuRef = React.useRef(null);

  const onMenuToggle = React.useCallback(() => {
    setMenu((menu) => !menu);
  }, []);

  const onClickDuplicate = React.useCallback(() => {
    onMenuToggle();
    onDuplicate();
  }, [onMenuToggle, onDuplicate]);

  const onClickDelete = React.useCallback(() => {
    onMenuToggle();
    onDelete();
  }, [onMenuToggle, onDelete]);

  React.useEffect(() => {
    /** @param {MouseEvent} event */
    function handleClickOutside(event) {
      if (!menuRef.current?.contains(event.target)) {
        setMenu(false);
      }
    }

    if (!menu) {
      return () => {};
    }

    window.addEventListener('click', handleClickOutside);

    return () => {
      window.removeEventListener('click', handleClickOutside);
    };
  }, [menu]);

  return (
    <div ref={menuRef} className="storefront-editor--sidebar-panel--actions">
      <button onClick={onMenuToggle} type="button">
        <Icon svgType="dots-horizontal" />
      </button>

      <ul
        aria-hidden={!menu}
        className="storefront-editor--sidebar-panel--actions--menu"
      >
        <li>
          <button onClick={onClickDuplicate} type="button">
            <StorefrontEditorIcon type="copy" />
            Duplicate
          </button>
        </li>

        <li className="storefront-editor--sidebar-panel--actions--menu--border">
          <button onClick={onClickDelete} type="button">
            <StorefrontEditorIcon type="trash" />
            Delete scheme
          </button>
        </li>
      </ul>
    </div>
  );
}

SwellColorPanelFooterActions.propTypes = {
  onDuplicate: pt.func,
  onDelete: pt.func,
};

export default React.memo(SwellColorPanelFooterActions);
